import { z } from "zod";

import { FixedDateRangeSchema } from "../constants";

export const QuickFilterRevenueConfigSchema = z.object({
  selectedTab: z.enum(["breakdown", "campaign", "adset", "ad"]),
  chartMetricIds: z.string().array(),
  alignAxesScale: z.boolean(),
  accountingMode: z.enum(["cash", "accrual"]),
  dateRange: z.union([
    z.enum([
      "yesterday",
      "today",
      "last3Days",
      "last7Days",
      "last14Days",
      "last30Days",
      "last60Days",
      "last6Months",
      "last12Months",
      "lastMonth",
      "monthToDate",
      "yearToDate",
    ]),
    FixedDateRangeSchema,
  ]),
  compareDateRange: z.union([
    z.object({
      value: z.literal("custom"),
      startDate: z.string(),
      endDate: z.string(),
    }),
    z.object({ value: z.enum(["previousPeriod", "samePeriodPriorYear"]) }),
  ]),
  timeGranularity: z.enum(["hourly", "daily", "weekly", "monthly"]).optional(),
  tableMetricIds: z.string().array(),
  sorting: z.object({ id: z.string(), desc: z.boolean() }).array(),
  breakdownIds: z.string().array(),
  breakdownFilters: z
    .object({ breakdown: z.string(), value: z.string() })
    .array(),
});
